import styled from "styled-components";

import { mixins, themeValues } from "../theme";

export const StyledModalShade = styled.div`
  position: fixed;
  z-index: 9999;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  min-width: 100%;
  height: 100vh;
  background-color: ${themeValues.modalShadeColor};
  transition: 0.2s;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex: 1;
  overflow-y: auto;
`;
StyledModalShade.displayName = "StyledModalShade";

export const StyledModalFrame = styled.div`
  ${mixins.rounded};
  ${mixins.boxShadow};

  background-color: white;
  font-size: 13px;
  overflow: hidden;
  width: 100%;

  &.width-small {
    max-width: 455px;
  }

  &.width-medium {
    max-width: 600px;
  }

  &.width-large {
    max-width: 850px;
  }

  &.width-xlarge {
    max-width: 1000px;
  }

  &.font-size-default {
    font-size: 13px;
  }

  &.font-size-upper {
    font-size: 14px;
  }

  margin-top: 5vh;
  animation: 0.3s ease-in-out 0s 1 slideInScale;
  margin-bottom: 24px;

  &.with-border {
    position: relative;

    &::after {
      position: absolute;
      content: "";
      bottom: 0;
      left: 0;
      width: 100%;
      height: 24px;
      background-color: #fff;
      z-index: 5;
    }
  }
`;
StyledModalFrame.displayName = "StyledModalFrame";

export const StyledModalBody = styled.div`
  max-height: 80vh;
  padding: 1.5rem 1.5rem 0;
  overflow-y: auto;
`;
StyledModalBody.displayName = "StyledModalBody";

export const StyledModalHeader = styled.div`
  position: relative;
`;
StyledModalHeader.displayName = "StyledModalHeader";

export const StyledModalClose = styled.i`
  margin-left: auto;
  cursor: pointer;
  position: absolute;
  top: 16px;
  right: 16px;
`;
StyledModalClose.displayName = "StyledModalClose";

export const StyledModalTitle = styled.div`
  font-size: 16px; // TODO: use from mixins
  font-weight: 500;
  display: flex;
  align-items: center;
  color: ${themeValues.darkColor};
  background-color: white;
  padding: 1rem 1.5rem;
`;
StyledModalTitle.displayName = "StyledModalTitle";

export const StyledModalFooter = styled.div`
  padding: 24px;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: end;
  justify-content: flex-end;
  
  & button:first-child {
    margin-right: 8px;
  }
`;
StyledModalFooter.displayName = "StyledModalFooter";

export const StyledModalInfo = styled.div`
  &.success {
    background-color: #78ffca;
    color: #222;
  }

  &.warn {
    background-color: #ffe478;
    color: #222;
  }

  padding: 0.75rem 1.5rem;
  position: relative;
  top: -1px;
  font-size: 0.85rem;
`;
StyledModalInfo.displayName = "StyledModalInfo";
